export const DATEPICKER_MAX_DATE_MESSAGE = "Data de início não pode ser posterior à data de fim";
export const DATEPICKER_MIN_DATE_MESSAGE = "Data de fim não pode ser anterior à data de início";
